import { usePathname } from 'expo-router';

const useVaroUserFlow = () => {
  const pathname = usePathname();
  const flow = pathname.startsWith('/reactivation') ? 'reactivation' : 'myvaro';

  return flow;
};

export default useVaroUserFlow;
